import axiosInstance from "../helpers/axiosHelper";
import { endpointsMetadata } from "../routes/endpointsMetadata";

interface FrontendErrorPayload {
  errorMessage: string;
  errorStack: string;
  pageUrl: string;
  userAgent: string;
  additionalInfo: string;
}

export const logFrontendError = async (
  error: Error,
  errorInfo: { componentStack?: string }
): Promise<void> => {
  try {
    const payload: FrontendErrorPayload = {
      errorMessage: error.message || "Unknown error",
      errorStack:
        error.stack || errorInfo.componentStack || "No stack trace available",
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
      additionalInfo: JSON.stringify({
        componentStack: errorInfo.componentStack,
        errorName: error.name,
        timestamp: new Date().toISOString(),
      }),
    };

    // Fire-and-forget pattern - don't await
    axiosInstance
      .post(endpointsMetadata.authentication.logFrontendError, payload)
      .catch((err) => {
        // Silently fail - we don't want error logging to cause more errors
        console.warn("Failed to log error to backend:", err);
      });
  } catch (err) {
    // Silently fail - we don't want error logging to cause more errors
    console.warn("Error while trying to log error:", err);
  }
};
